import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_REPORTS':
    case 'REQUEST_REPORT':
      return Object.assign({}, state, {
        loading: action.loading
      })
    case 'RECEIVE_REPORTS':
      return Object.assign({}, state, {
        reportList: action.payload.reportList,
        loading: action.loading
      })
    case 'CREATE_REPORT':
      const newReportList = [{ ...action.payload.newReport }, ...state.reportList]
      return Object.assign({}, state, {
        reportList: newReportList,
        loading: action.loading
      })
    case 'RECEIVE_REPORT':
      return Object.assign({}, state, {
        reportDetail: action.payload.reportDetail,
        loading: false
      })
    case 'CLEAR_REPORT':
      return Object.assign({}, state, {
        reportDetail: null
      })
    default:
      return state
  }
}

export default reducer
